<template>
  <div class="wrap" :class="{'weatherloggedin': this.is_logged_in}">

    <div class="container" >
			<div class="row" v-if="is_logged_in === false">
				<div class="col-lg-8 mx-auto">
					<p>
						View data for all 150+ weather stations for <b>free</b> with an Ag Alliance membership. Also receive deep
						discounts not available anywhere else on innovative agribusiness
						technologies, get access to regional trends, and be a part of the
						Wabash Heartland Innovation Network.
					</p>
				</div>
				<div class="col-lg-4 mx-auto text-center">
					<a href="javascript:void(0);" class="button btn btn-primary" data-toggle="modal" data-target="#login-modal">Alliance member login</a>
					<br />
					<a href="mailto:alliances@whin.org">Contact us to become an alliance member</a>
				</div>
			</div>
      <div class="row" v-if="is_logged_in === true">
				<div class="col-lg-12 mx-auto text-center">
<!--					<img src="../img/logos/demo.png" style="width:32px;height:32px;position:relative;top:-3px;">-->
					You are logged in as {{ logged_in_display_name }}. <a style="font-size:smaller;" href="#" @click="handleLogout">[Logout]</a>
				</div>
      </div>
		</div>

    <!-- Modal -->
    <div class="modal fade" ref="loginmodal" id="login-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">
              <img src="./assets/img/x.svg" alt="X" title="Close" />
            </span>
          </button>
          <div class="modal-body">
            <p style="text-align:center; font-weight:bold; font-size:1.3rem;">
              Agriculture Alliance member login
            </p>
            <form id="loginForm" ref="form" @submit.prevent.stop="handleLogin">
              <input type="text" placeholder="Email" v-model="username" required /><br />
              <input type="password" placeholder="Password" v-model="password" value="" required /><br />
              <div class="text-center">
                <button id="loginFormSubmit" type="submit" class="btn btn-dark">Submit</button>
              </div>
              <div class="err text-danger" v-show="error_message !== null">
                <br>
                {{ error_message }}
              </div>
              <div class="" v-show="is_loading">
                <br>
                Logging in...
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <p>
              Wabash Heartland Innovation Network<br />
              1281 Win Hentschel Boulevard Suite 2161<br />
              West Lafayette, Indiana 47906<br />
              &nbsp;
              <a href="mailto:info@whin.org">info@whin.org</a>
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import api from "@/api";
  import bus from "@/bus";
  import $ from "jquery"

  export default {
    name: "LoginApp",
    data: function() {

      return {
        username: null,
        password: null,
        is_loading: false,
        error_message: null,
        is_logged_in: api.isLoggedIn(),
        logged_in_display_name: api.getLoggedInUserName(),
      };
    },
    created() {

      bus.$on("session-login", (user) => {
        this.is_logged_in = true;
        this.logged_in_display_name = user.displayName;
      });
      bus.$on("session-logout", () => {
        this.is_logged_in = false;
        this.logged_in_display_name = "";
      });

    },
    mounted() {
      bus.$on("show-login-modal", () => {

      });
    },
    methods: {
      async handleLogin() {

        let data = {username: this.username, password: this.password};
        this.is_loading = true;
        this.error_message = null;

        if (this.username === null || this.username.length < 1) {
          this.error_message = "Email is required";
          return;
        }
        if (!this.password) {
          this.error_message = "Password is required";
          return;
        }

        try {
          let respData = await api.loginRequest(data);
          this.is_loading = false;
          if (respData.token !== undefined) {
            // Hide the modal, we've logged in
            $("#login-modal").modal('hide');
            //this.$refs.loginmodal.modal('hide');
          } else if (respData.description !== undefined) {
            // Show error
            this.error_message = respData.description;
          }
        } catch (error) {
          this.is_loading = false;
          console.error('Error:', error);
          this.error_message = "There was a problem logging in";
        }

      },
      async handleLogout() {
        api.logout();
      }
    }
  }
</script>

<style scoped>

.wrap {
	background-color: rgba(0,191,176,0.2);
	border: 1px solid rgba(0,191,176,0.333);
	padding: 1.5rem;
}
.wrap.weatherloggedin {
	background-color: #0f6258;
	color: #fff;
	font-size: 1.25rem;
	font-weight: bold;
	padding: 1rem;
}
.weatherloggedin .btn {
	font-size: 1.25rem;
  margin: 0.5rem 0 0 0;
  padding: 0.5rem 1.5rem;
}

.loggedin .btn {
	font-size: 1.25rem;
    margin: 0.5rem 0 0 0;
    padding: 0.5rem 1.5rem;
}

</style>